module.exports = __webpack_public_path__ + "static/img/ss.2cec874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ss.png
// module id = rlAo
// module chunks = 1